// src/modules/app-views/goodsReceipt/pages/Document/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { MoreOutlined, InboxOutlined, DeleteOutlined } from '@ant-design/icons';
import {
  dropdownNew,
  dropdownDuplicate,
  dropdownDivider,
  dropdownRestore,
  dropdownRemovePermanently,
  dropdownParameters,
} from 'layouts/Pages/PageHeader/dropdownMenus';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const goodsReceiptDocumentMenuButton = () => {
  return {
    action: 'dropdownMenu',
    icon: <MoreOutlined />,
    tooltip: 'more_options',

    dropdownItems: [
      // Standard navigation actions
      dropdownNew,
      dropdownDuplicate,

      dropdownDivider,

      // Archive - disabled when document is confirmed or cancelled
      {
        key: 'archive',
        label: 'archive_document',
        icon: <InboxOutlined />,
        hidden: ({ currentPage }) => !!currentPage?.data?._metadata?.audit?.removedAt,
        disabled: ({ currentPage }) => {
          const status = currentPage?.data?.status;
          if (!currentPage?.data?._id) return true;
          return status === 'confirmed' || status === 'cancelled';
        },
        onClick: ({ handleArchiveDocuments, page, handleListRefresh }) => {
          const data = page?.data;
          if (!data?._id) return;
          handleArchiveDocuments?.([data], { onSuccess: handleListRefresh });
        },
      },

      // Remove - disabled when document is confirmed or cancelled
      {
        key: 'remove',
        label: 'remove',
        icon: <DeleteOutlined />,
        hidden: ({ currentPage }) => !!currentPage?.data?._metadata?.audit?.removedAt,
        disabled: ({ currentPage }) => {
          const status = currentPage?.data?.status;
          if (!currentPage?.data?._id) return true;
          return status === 'confirmed' || status === 'cancelled';
        },
        danger: true,
        onClick: ({ handleRemoveDocuments, page, handleListRefresh }) => {
          const data = page?.data;
          if (!data?._id) return;
          handleRemoveDocuments?.([data], { onSuccess: handleListRefresh });
        },
      },

      dropdownRestore,
      dropdownRemovePermanently,

      dropdownDivider,
      dropdownParameters,
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default goodsReceiptDocumentMenuButton;
